import React, { useState } from 'react';
import { useTheme } from '@/context/ThemeContext';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import ChatInputCustomParametersModal from '@/components/Modal/ChatInputCustomParametersModal';
import ChatInputMobileMenuButton from './ChatInputMobileMenuButton';

export default function ChatInputParametersButton({ menuParams, onPress, ...props }) {
  const [open, setOpen] = useState(false);
  const { colors } = useTheme();
  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen} modal={false}>
      <DropdownMenu.Trigger asChild disabled={props.disabled}>
        <ChatInputMobileMenuButton {...props} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        className="DropdownMenuContent"
        align="start"
        side="top"
        sideOffset={8}
        collisionPadding={12}
        onInteractOutside={event => {
          // Parameter option menus render in their own portal.
          if (event.target.closest?.('.DropdownMenuContent')) event.preventDefault();
        }}
        style={{
          width: 340,
          maxWidth: 'calc(100vw - 24px)',
          maxHeight: 'min(480px, var(--radix-dropdown-menu-content-available-height))',
          overflowY: 'auto',
          padding: 6,
          backgroundColor: colors.solid_color_primary,
          borderRadius: 12,
        }}
      >
        <ChatInputCustomParametersModal {...menuParams} embedded onClose={() => setOpen(false)} />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
